import { useQuery } from "@tanstack/react-query";

export function useMyTags() {
  return useQuery<string[]>({
    queryKey: ["my-tags"],
    queryFn: () => fetch("/api/books/my-tags/").then((r) => r.json()),
  });
}
